import { render, staticRenderFns } from "./ItemCardRealEstate.vue?vue&type=template&id=0eaedfb1&scoped=true&"
import script from "./ItemCardRealEstate.vue?vue&type=script&lang=js&"
export * from "./ItemCardRealEstate.vue?vue&type=script&lang=js&"
import style0 from "./ItemCardRealEstate.vue?vue&type=style&index=0&id=0eaedfb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaedfb1",
  null
  
)

export default component.exports